<h1 class="text-dark text-xl" mat-dialog-title>Nuova associazione veicolo</h1>
<div class="w-full" mat-dialog-content>
  <app-form-associate-insurance-to-vehicle
    [dialogRef]="dialogRef"
    [data]="data"
    [selectedPractices]="selectedPractices"
  ></app-form-associate-insurance-to-vehicle>
</div>
